/* eslint-disable */
<template>
  <div>
  <userGuide ref="userGuideModal" />
  <notifications />
  <Navmenu v-if="showMenu" :navactive="navactive" @expandnav="expandNav" />
  <div class="mainContent mobPortraitHide FullminHt mainmar" id="app"
    v-bind:class="[!isexpand ? 'BlurClass' : '', navmargin ? 'navmar' : '']">
    <div class="content-region" id="allPages">
      <div>
        <router-view @getflname="getflname" />
      </div>
      <canvas id="samplecat" class="chartHghtControl" v-show="chartClr"></canvas>
    </div>
  </div>
  <header id="header" class="header static-xs cast-shadow fixed-top" v-bind:class="[!showHeader ? 'homeHeader' : '']">
    <div style="width: 50%; display: inline-block;">
      <img :src="require(`./assets/images/${lightLogo}`)" v-show="$store.state.TClrs != 'darkTheme'" class="customerLogo"
        :class="!showHeader ? 'home' : 'noHome'">
      <img :src="require(`./assets/images/${darkLogo}`)" v-show="$store.state.TClrs == 'darkTheme'" class="customerLogo"
        :class="!showHeader ? 'home' : 'noHome'">
    </div>
    <div class="text-end" style="width: 50%; display: inline-block;">
      <div class="myHdrIcon" style="display: inline-block;" aria-label="User Guide" data-balloon-pos="down">
        <font-awesome-icon icon="fa-solid fa-person-circle-question" class="headerIcons" v-on:click="showUGModal()" />
      </div>
      <div class="btn-group " style="display: inline-block;">
        <button type="button" class="myHdrIcon themeIcn style-reset dropdown-toggle p-0"
          :class="isDark ? 'darkIcn' : 'lightIcn'" @click.prevent="showDropDown()">
          <a href="#" aria-label="Change color" data-balloon-pos="down">
            <font-awesome-icon :icon="['fas', 'palette']" class="headerIcons" />
          </a>
        </button>
        <ul class="dropdown-menu"
          style=" position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate(0px, 42px); z-index: 9999999999;"
          :style="showDrop ? 'display: block' : 'display: none'">
          <li>
            <a class="dropdown-item d-flex justify-content-between align-items-center py-0 my-0"
              @click="BaseThemeChange('theme')">
              <small class="p-0 m-0 color">Dark/ Light Theme</small>
              <button class="myHdrIcon themeIcn style-reset " :class="isDark ? 'darkIcn' : 'lightIcn'"
                data-balloon-pos="down" aria-label="Change Theme">
                <font-awesome-icon icon="fa-solid fa-sun" class="headerIcons color" v-show="isDark" />
                <font-awesome-icon icon="fa-solid fa-moon" class="headerIcons color" v-show="!isDark" />
              </button>
            </a>
          </li>
          <li v-show="isChartAvail">
            <hr class="dropdown-divider">
          </li>
          <li v-show="isChartAvail">
            <small class="p-0 m-0 color px-3">Widget Color
              <span class=" ms-2" aria-label="Applies to single color charts." data-balloon-pos="up"
                data-balloon-length="large">
                <font-awesome-icon :icon="['fas', 'info-circle']" class="cursor-pointer fontSz10" />
              </span></small>
            <div class="row g-4 p-4 justify-content-between pb-1">
              <!-- in array first color is low and second color is hight -->
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn mb-0"
                style="background-color: #1b6c86;" @click="widgetColor('blue')"
                :class="chartWidgetColorName == 'blue' ? 'active' : ''"></button>
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn"
                style="background-color: #FF3B30;" @click="widgetColor('redOrange')"
                :class="chartWidgetColorName == 'redOrange' ? 'active' : ''"></button>
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn"
                style="background-color: #FFCC00;" @click="widgetColor('yellow')"
                :class="chartWidgetColorName == 'yellow' ? 'active' : ''"></button>
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn"
                style="background-color: #009688;" @click="widgetColor('teal')"
                :class="chartWidgetColorName == 'teal' ? 'active' : ''"></button>
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn"
                style="background-color: #9c27b0;" @click="widgetColor('purple')"
                :class="chartWidgetColorName == 'purple' ? 'active' : ''"></button>
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn"
                style="background-color: #003176;" @click="widgetColor('prussianBlue')"
                :class="chartWidgetColorName == 'prussianBlue' ? 'active' : ''"></button>
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn"
                style="background-color: #7C0C0B; " @click="widgetColor('red')"
                :class="chartWidgetColorName == 'red' ? 'active' : ''"></button>
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn"
                style="background-color: #FF2D55; " @click="widgetColor('pink')"
                :class="chartWidgetColorName == 'pink' ? 'active' : ''"></button>
              <button type="button" class="dropdown-item btn rounded-pill btn-sm col-3 m-1 widget-btn"
                style="background-color: #005200;" @click="widgetColor('green')"
                :class="chartWidgetColorName == 'green' ? 'active' : ''"></button>
            </div>
          </li>
        </ul>
      </div>
      <div class="myHdrIcon text-center logout-btn" style="display: inline-block;margin-right: 5px;">
        <span class="headerIcons primaryTxt">
          <div class="dropdown" v-show="BuExists != false">
            <div class="dropdown-toggle drpSett" id="single-button" data-bs-toggle="dropdown">
              <div class="nameCircle">{{ flname }}</div>
            </div>
            <div class="dropdown-menu extended" role="menu">
              <div class="notify-arrow notify-arrow-green"></div>
              <a class="dropdown-item" v-on:click="logoutFromBack()">
                <font-awesome-icon icon="fa-solid fa-arrow-right-from-bracket" />
                LogOut
              </a>
            </div>
          </div>
        </span>
      </div>
    </div>
  </header>
  <footer class="site-footer pageFooter" v-bind:class="[!isexpand ? 'BlurClass' : '']">
    <div>
      <span style="float: left;font-size: 1rem;">
        <img src="./assets/images/o.svg" id="appIcon" class="appIcon" alt="OPSight Icon">
        PSIGHT
      </span>
      <span class="position-relative" style="width: 50%; display: inline-block;">
        <span class="myInfoI uSpl">v5.1</span>
        <span class="myInfoS">
          <b class="themeclr2 mb-2 d-block">What's New: </b><br />
          <ul class="about-release">
            <li>APPM admin page</li>
            <li>Weekly dashboard for CIS admin</li>            
            <li>UI/UX Enhancements</li>
            <li>Statutory Bugfixes</li>
          </ul>
        </span>
        <span>
        &copy;
        Copyrights <strong>EAI - LTIMindtree</strong>. All Rights
        Reserved </span>
      </span>
    </div>
  </footer>
  <div class="rotat-device-screen" v-if="showRotateMsg">
    <div style="position: relative; left: -32px;">
      <div class="phone"> </div>
      <div class="message">
        Please rotate your device!
      </div>
    </div>
  </div>
  <div class="myLoadBack" v-show="ishmload">
    <div class="d-flex align-items-center justify-content-center h-100">
      <pageLoaderComp></pageLoaderComp>
    </div>
  </div>
  </div>
</template>
<script>
import Navmenu from './components/navMenu.vue'
import pageLoaderComp from './components/smallcomp/pageloader.vue'
import router from './router/index.js'
import userinMix from './mixin/userinMix'
import userGuide from './components/userGuide.vue'
import {
  useRoute
} from 'vue-router'
export default {
  name: 'App',
  components: {
    Navmenu,
    userGuide,
    pageLoaderComp
  },
  mixins: [userinMix],
  setup() {
  },
  data() {
    return {
      dataLoads: false,
      userInfo: {},
      ishmload: false,
      activateErr: false,
      navmargin: false,
      showHeader: false,
      showLgThm: false,
      showlgout: false,
      showMenu: false,
      isexpand: true,
      navactive: 0,
      isDark: true,
      nexSteps: false,
      chartClr: false,
      BuExists: false,
      currPage: "",
      asgID404: "",
      confirmStayInDirtyForm: false,
      flname: "",
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
      warningTimer: null,
      lightLogo: "companyLogoD.png",
      darkLogo: "companyLogoD.png",
      chartWidgetColor: [],
      chartWidgetColorName: null,
      showDrop: false,
      showRotateMsg: false,
      isChartAvail: false,
    }
  },
  mounted() {
    this.events.forEach(event => {
      window.addEventListener(event, this.resetTimer);
    })
    this.setTimers();
    const route = useRoute()
    router.afterEach((to) => {
      if(to.name == 'inquisightPage' || to.name == 'visualizationPage' ||to.name == 'dataQualityPage' ){
        this.isChartAvail = true
      }else{
        this.isChartAvail = false
      }
      if (to.name != "missing404Page") {
        this.showLgThm = true
        sessionStorage.asgID404 = to.params.asgid
      }
      if (to.name != "homePage") {
        this.onUserValidate()
      }
      if (to.name == 'homePage') {
        this.navmargin = false
        this.showHeader = false
        this.showMenu = false
      } else if (to.name == 'adminPage' || to.name == 'analyticsPage' || to.name == 'approvalPage'  || to.name == 'ppmRuleForm' || to.name == 'adminPprDashboard' || to.name == 'adminRulesAndTowers' || to.name == 'adminAppm' || to.name == 'regex'|| to.name == 'adminViewPpr'|| to.name == 'adminMisDashboard'|| to.name == 'adminCisWeekly'|| to.name == 'adminCmf') {
        this.navmargin = false
        this.showHeader = true
        this.showMenu = false
      } else if (to.name == 'missing404Page') {
        this.navmargin = false
        this.showHeader = false
        this.showMenu = false
      } else {
        this.navmargin = true
        this.showHeader = true
        this.showMenu = true
        this.asgId = route.params.asgid
        this.asgDetails()
      }
      if (to.name == 'homePage') {
        this.showlgout = false
      } else {
        this.showlgout = true
      }
      this.showRotateMsg = false;
      switch (to.name) {
        case 'setupPage':
          this.navactive = 1
          this.showRotateMsg = true;
          break
        case 'dataQualityPage':
          this.navactive = 2
          this.showRotateMsg = true;
          break
        case "visualizationPage":
          this.navactive = 3
          this.showRotateMsg = true;
          break
        case 'slidePage':
          this.navactive = 4
          this.showRotateMsg = true;
          break
        case 'inquisightPage':
          this.navactive = 5
          break
        case 'TaggingPage':
          this.navactive = 6
          this.showRotateMsg = true;
          break
        case 'appmHome':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'appmCore':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'pprDashboard':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'misDashboard':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'ruleInput':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'pprConsole':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'approvalPprConsole':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'viewPpr':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'ppmRuleInput':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'historyAppm':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'viewRule':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'viewIncident':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'workflow':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'appmUserPermissions':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        case 'myWorkPlace':
          this.navactive = 7
          this.showRotateMsg = true;
          break
        default:
          break
      }
      this.currPage = to.name;
    })
  },
  beforeRouteLeave(to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    if (this.confirmStayInDirtyForm()) {
      next(false)
    } else {
      // Navigate to next view
      next()
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
    if (this.$sessionData.length > 0 && this.$sessionData.uinofo_sess != undefined) {
      if (this.$sessionData.uinofo_sess.userstatus == "NotApproved" || this.$sessionData.uinofo_sess
        .userstatus ==
        "Newaccount" || this.$sessionData.uinofo_sess.userstatus == "BUexpired") {
        this.activateErr = true;
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  computed: {},
  methods: {
    showDropDown() {
      this.showDrop = !this.showDrop
    },
    setWidgettColor(color) {
      this.chartWidgetColorName = color
      switch (color) {
        case 'blue':
          this.chartWidgetColor = ['#78aebf', '#1b6c86']
          break;
        case 'prussianBlue':
          this.chartWidgetColor = ['#00C9FF', '#003176']
          break;
        case 'red':
          this.chartWidgetColor = ['#FF9393', '#7C0C0B']
          break;
        case 'green':
          this.chartWidgetColor = ['#BEF671', '#005200']
          break;
        case 'teal':
          this.chartWidgetColor = ['#009688', '#97D4CE']
          break;
        case 'redOrange':
          this.chartWidgetColor = ['#FF817A', '#FF3B30']
          break;
        case 'yellow':
          this.chartWidgetColor = ['#FFE57D', '#ffcc00']
          break;
        case 'purple':
          this.chartWidgetColor = ['#CD91D7', '#9c27b0']
          break;
        case 'pink':
          this.chartWidgetColor = ['#FF94A8', '#ff2d55']
          break;
        default:
          this.chartWidgetColor = ['#78aebf', '#1b6c86']
          break;
      }
      this.$store.dispatch('setWidgetColor', this.chartWidgetColor)
    },
    widgetColor(color) {
      this.setWidgettColor(color)
      this.BaseThemeChange('color')
    },
    showUGModal() {
      this.$refs.userGuideModal.showUGModal(this.currPage)
    },
    resetTimer() {
      clearTimeout(this.warningTimer)
      this.setTimers()
    },
    setTimers() {
      this.warningTimer = setTimeout(this.warninMeaasge, 9000000);
    },
    warninMeaasge() {
      this.logOut(0)
    },
    expandNav() {
      this.navmargin = !this.navmargin
      this.isexpand = !this.isexpand
    },
    clearAllCookies() {
      const cookies = document.cookie.split(";");
      for (let cookie of cookies) {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    },
    logoutFromBack(){
      this.ishmload = true;
			const allCookies = document.cookie;
			const cookieArray = allCookies.split('; ');
			let kcToken;
			for (let i = 0; i < cookieArray.length; i++) {
				const cookie = cookieArray[i].split('=');
				if (cookie[0] === 'keycloakToken') {
					kcToken = cookie[1];
					break;
				}
			}
			let UVobj = {"token": decodeURIComponent(kcToken)}
			this.axios.post(this.uriApiUrl + 'UserSetting/logout?',UVobj,{
			headers: {
					'Content-Type': 'application/json'
				}})
				.then((response) => {
					if (response.status == 200) {
						if (response.data != "Error") {
              this.ishmload = false;
							this.logOut(0)
							this.$notify({
								type: "info",
								text: 'logout successfully.'
							})
						}
					}
				}).catch((error) => {
          this.ishmload = false;
          sessionStorage.clear();
          localStorage.clear();
          this.clearAllCookies()
          location.reload()
					this.$notify({
						type: "error",
						text: 'Error.'
					})
				})
		},
    logOut(val) {
      if (val == 0) {
        sessionStorage.clear();
        localStorage.clear();
        this.$keycloak.logout();
        this.clearAllCookies()
      } else {
        localStorage.clear();
        sessionStorage.clear();
        this.$keycloak.logout();
        this.clearAllCookies()
      }
    },
    getflname(name, basetheme) {
      this.BuExists = true
      let UserName = this.toProperCase(name)
      var unamesplit = UserName.split(' ')
      this.flname = unamesplit[0].charAt(0) + unamesplit[1].charAt(0)
      this.getBaseTheme(basetheme)
    },
    onUserValidate() {
      let UVobj = {"Base_Color": "Dark"}
      this.axios.post(this.uriApiUrl + 'UserSetting/getuserdetails?',UVobj,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          this.userInfo = response.data
          if (this.userInfo == "Error") {
            this.$notify({
              type: "error",
              text: "Something Went Wrong. Please retry and if you still face issues contact the support team"
            })
          } else if (this.userInfo.userstatus == "BUexpired") {
            this.$router.push({
              name: 'homePage'
            })
          } else if (this.userInfo.userstatus == "Activated") {
            this.$sessionData.set('uinofo_sess', this.userInfo)
            this.BuExists = true
            let UserName = this.toProperCase(this.userInfo.UserName)
            var unamesplit = UserName.split(' ')
            this.flname = unamesplit[0].charAt(0) + unamesplit[1].charAt(0)
            this.getBaseTheme(this.userInfo.base_Color)
            this.setWidgettColor(this.userInfo.widget_Color)
          }
        })
        .catch((error) => {
          this.$notify({
            type: "error",
            text: "Something Went Wrong. Please retry and if you still face issues contact the support team"
          })
        })
    },
    toProperCase(inpt) {
      return inpt.replace(/\w\S*/g, function (txt) {
        let vv = txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        return vv
      })
    },
    getBaseTheme(basetheme) {
      if (basetheme == "light") {
        this.isDark = false
        this.$store.state.TClrs = "lightTheme"
        document.body.classList.add("lightTheme")
        document.body.classList.remove("darkTheme")
      } else {
        this.isDark = true
        this.$store.state.TClrs = "darkTheme"
        document.body.classList.add("darkTheme")
        document.body.classList.remove("lightTheme")
      }
    },
    BaseThemeChange(widgetCol) {
      var getTheme = this.$sessionData.get('uinofo_sess')
      var basetheme = getTheme.base_Color
      if (widgetCol == 'theme') {
        if (basetheme == "light") {
          this.isDark = true
          this.$store.state.TClrs = "darkTheme"
          document.body.classList.add("darkTheme")
          document.body.classList.remove("lightTheme")
          basetheme = "dark"
        } else {
          this.isDark = false
          this.$store.state.TClrs = "lightTheme"
          document.body.classList.add("lightTheme")
          document.body.classList.remove("darkTheme")
          basetheme = "light"
        }
      }
      let BTobj = {
        "Base_Color": basetheme,
        "Widget_Color": this.chartWidgetColorName
      }
      this.axios.post(this.uriApiUrl + 'UserSetting/saveusertheme?userData=' + JSON.stringify(BTobj),{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error") {
              if (widgetCol == 'theme') {
                this.$notify({
                  type: "success",
                  text: "Theme saved successfully"
                })
              } else {
                this.$notify({
                  type: "success",
                  text: "Widget color saved successfully."
                })
              }
              this.showDrop = false
              getTheme.base_Color = basetheme
              this.$sessionData.set('uinofo_sess', getTheme)
              this.$store.dispatch('setWidgetColor', this.chartWidgetColor)
            } else {
              this.$notify({
                type: "error",
                text: "Not Able to Switch !Try Again."
              })
            }
          }
        }).catch((error) => {
          this.$notify({
            type: "error",
            text: "Connection Issue! Please try again."
          })
        })
    },
    asgDetails() {
      this.dataLoads = true
      this.axios.get(this.uriApiUrl + 'UserSetting/getassessment?asg_id=' + this.asgId + "&Cond=" + 0,{
        headers: {
            'Content-Type': 'application/json'
          }
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data == "404") {
              this.$sessionData.set('pgresp', response.data)
              this.$router.push('/Page404')
            } else if (response.data == "403") {
              this.$sessionData.set('pgresp', response.data)
              this.$router.push('/Page404')
            } else if (response.data == "301") {
              this.showHeader = false
            } else if (response.data == "Error") {
              this.$notify({
                type: "error",
                text: "Sorry, not able to Load the assessment. Please try after some time"
              })
            } else {
              var asginfo = response.data
              asginfo.asgId = this.asgId
              asginfo.isAppmToShow = asginfo.is_appm
              let nexSteps = asginfo.is_uploaded
              this.$store.commit({
                type: 'getAsg',
                AsgName: asginfo.assessment_name,
                Is_bookmark: asginfo.is_bookmark,
                isOwner: asginfo.isowner
              })
              this.$store.commit("navSteps", nexSteps)
              this.$store.dispatch('storeIsLive',  asginfo)

            }
            this.dataLoads = false
          }
        }).catch((error) => {
          this.$notify({
            type: "error",
            text: "Connection Issue! Please try again."
          })
        })
    }
  }
}
</script>
<style scoped>
.homeHeader {
  -webkit-backdrop-filter: blur(0) !important;
  backdrop-filter: blur(0) !important;
  background: none !important;
  box-shadow: none !important;
}

.homeHeader .appTitleName {
  display: none;
}

.myHdrIcon.themeIcn.darkIcn:hover .headerIcons {
  color: #ecad39cd !important;
}

.myHdrIcon.themeIcn.lightIcn:hover .headerIcons {
  color: #6039eccd !important;
}

.canvasLogo {
  display: inline-block;
  height: 12px;
  margin-right: 5px;
}

.customerLogo {
  display: inline-block;
  height: 30px;
  margin-right: 8px;
  margin-left: 8px;
}

.customerLogo::after {
  content: "|";
}

.myInfoI:hover+.myInfoS {
  bottom: 28px;
  text-align: left;
  right: 24%;
}

.myFakeBullet {
  margin-left: 10px;
}

.customerLogo.home {
  position: absolute;
  left: 10px;
  top: 10px;
}

.style-reset {
  background-color: transparent;
  border: none;
  outline: none;
  color: inherit;
}

.darkTheme .color {
  color: #fff;
}

.widget-btn {
  height: 24px;
  border: none;
  width: 30%;
  color: #fff !important;
  padding: 0;
  text-align: center;
  font-size: 11px;
}

.widget-btn.active {
  border: 2px solid #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
}

.dropdown-item:hover,
.dropdown-item:focus {
  background-color: transparent;
}

.darkTheme .logout-btn .dropdown-item {
  color: #fff;
}
.darkTheme .logout-btn .dropdown-item:hover{
  background-color: inherit !important;
}
.about-release, .about-release ul{
  padding-left: 16px;
  margin-bottom: 8px;
}
.about-release > li{
  list-style: disc;
  font-size: 13px;
  margin-bottom: 4px;
}
.about-release ul li{
  list-style: circle;
}
</style>